module.exports = __webpack_public_path__ + "static/img/5.08e9f95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shenghe/5.png
// module id = hBsz
// module chunks = 19